import Axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

const CityPage = () => {
  const params = useParams();
  const { city } = params;
  const [competitions, setCompetitions] = useState([]);
  const [cityReg, setCityReg] = useState({});
  const navigate = useNavigate();

  const fetchAllCompetitions = () => {
    Axios.get(`https://ashish.moodi.org/multicity/get_mul_compi?city=${city}`)
      .then((res) => setCompetitions(res.data))
      .catch((err) => console.error(err));
  };

  const fetchTotalCityReg = () => {
    Axios.get(`https://ashish.moodi.org/multicity/mul_total_reg?city=${city}`)
      .then((res) => setCityReg(res.data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    if (localStorage.getItem("compiauthtoken")) {
      fetchAllCompetitions();
      fetchTotalCityReg();
    } else {
      navigate("/admin/login");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container-fluid">
      <h2 className="title">{city}</h2>
      <div className="row">
        <h5 className="col-4">Solo : {cityReg.solo}</h5>
        <h5 className="col-4">Teams : {cityReg.teams}</h5>
      </div>
      <ul>
        {competitions.map((competition) => {
          return (
            <li key={competition.mcId}>
              <Link to={`/admin/multicity/competition/${competition.mcId}`}>
                {competition.mcName}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default CityPage;
